import React, { useState } from "react";
import { IoSpeedometer } from "react-icons/io5";
import { RiPaintBrushFill } from "react-icons/ri";
import { formatNumberComma, formatNumber } from "../utils/numberUtils";

const VehicleList = ({ data = [], type = "", condition = true }) => {
  const defaultCarImage = "/car-placeholder.jpg";
  const [imageLoading, setImageLoading] = useState(true);

  // Function to handle image loaded successfully
  const handleImageLoaded = () => {
    setImageLoading(false); // Set image loading state to false when loaded
  };

  return (
    <>
      <div className='card-list'>
        {data.map((car, index) => {
          let imageSrc =
            car?.featured_image_url || car?.media?.photo_links[0] || "";

          return (
            <div key={index} className='list-item'>
              <a
                    href={`/details/?detail_id=${car.id}${
                      car.id.length > 5 && type !== "" ? `&type=${type}` : ""
                    }`}
                  >
                <div>
                  <img
                    src={imageSrc} // Load actual car image once available
                    alt='Car'
                    className={`car-image ${imageLoading ? "hidden" : ""}`}
                    onLoad={handleImageLoaded} // Call function when image loads
                    onError={(e) => {
                      e.target.src = defaultCarImage; // Set default image on error
                      setImageLoading(false); // Ensure loading state is turned off
                    }}
                  />
                </div>
              </a>

              <div className='list-content'>
                <h3>
                <a
                    href={`/details/?detail_id=${car.id}${
                      car.id.length > 5 && type !== "" ? `&type=${type}` : ""
                    }`}
                  >
                    {condition && (
                      <>
                        {(
                          car?.hp_listing_v_details_condition?.[0]?.name ||
                          (car?.inventory_type?.includes("used")
                            ? "USED"
                            : "NEW")
                        )?.toUpperCase()}
                      </>
                    )}{" "}
                    {car?.meta?.hp_v_essentials_year || car?.build?.year}{" "}
                    {car?.meta?.hp_v_essentials_make || car?.build?.make}{" "}
                    {car?.meta?.hp_v_essentials_make_model || car?.build?.model}
                  </a>
                  <span
  className="original-name"
  dangerouslySetInnerHTML={{
    __html: `(${car?.title?.rendered || car?.heading})`,
  }}
></span>
                </h3>
                {car?.dealer?.name && (
                  <span className='car-attr'>
                    <strong>Dealer:</strong>{" "}
                    <a href={car?.vdp_url}>{car?.dealer?.name}</a>
                  </span>
                )}
                {car?.meta?.hp_location && (
                  <div className='car-attr'>
                    <span>{car?.meta?.hp_location}</span>
                  </div>
                )}
                <div className='car-attr'>
                  {car?.meta?.hp_v_details_mileage ? (
                    <span>
                      <IoSpeedometer />{" "}
                      {formatNumberComma(car.meta.hp_v_details_mileage)} miles
                    </span>
                  ) : car?.miles ? (
                    <span>
                      <IoSpeedometer /> {formatNumberComma(car.miles)} miles
                    </span>
                  ) : null}
                  {car?.hp_listing_v_details_exterior_co?.[0]?.name ? (
                    <span>
                      <RiPaintBrushFill />{" "}
                      {car?.hp_listing_v_details_exterior_co?.[0]?.name}
                    </span>
                  ) : car?.exterior_color ? (
                    <span>
                      <RiPaintBrushFill /> {car?.exterior_color}
                    </span>
                  ) : null}
                </div>
                {car?.meta?.hp_price ? (
                  <span className='car-attr price-tag'>
                    ${formatNumber(car?.meta?.hp_price)}
                  </span>
                ) : car?.price ? (
                  <span className='car-attr price-tag'>
                    ${formatNumber(car?.price)}
                  </span>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default VehicleList;
